let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Bglp")).then(() => parcelRequire('7O8th'));